import { render, staticRenderFns } from "./ProductionOrderCertificate.vue?vue&type=template&id=38514ad8"
import script from "./ProductionOrderCertificate.vue?vue&type=script&lang=js"
export * from "./ProductionOrderCertificate.vue?vue&type=script&lang=js"
import style0 from "./ProductionOrderCertificate.vue?vue&type=style&index=0&id=38514ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports